import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-table-page',
  templateUrl: './table-page.component.html',
  styleUrls: ['./table-page.component.scss']
})
export class TablePageComponent implements OnInit {
  numTowns = 1;

  constructor() { }

  ngOnInit() {
  }

  AddTown() {
    this.numTowns++;
    if( this.numTowns > 3 )
      this.numTowns = 3;
  }
  RemoveTown() {
    this.numTowns--;
    if( this.numTowns < 1 )
      this.numTowns = 1;
  }

  GetArray() {
    return Array(this.numTowns).fill(1);
  }
}